import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef } from "vue"

import { ref, computed, watch, onUnmounted } from 'vue'
import { debounce } from 'lodash'
import { ElMessage } from 'element-plus'
import { UpdateCooperation } from '@/api/operation'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import SelectOperator from '@/components/SelectOperator.vue'
import useI18nTl from '@/hooks/useI18nTl'


export default /*#__PURE__*/_defineComponent({
  props: {
  modelValue: Boolean,
  data: Object
},
  emits: ['update:modelValue', 'success'],
  setup(__props, { emit }) {

const props = __props

const { CooperStates, CooperTypes } = useProtocolEnums()
const { t } = useI18nTl('Base')





const visible = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
})

const formData = ref(props.data || {}) // 确保有默认空对象


// 组件卸载时清除防抖
onUnmounted(() => {
})

watch(() => props.data, (newVal) => {
  formData.value = {...newVal} // 监听props.data变化并更新formData
}, { immediate: true })

const handleSubmit = async () => {
  try {
    // 确保提交的是完整的formData对象
    const submitData = {
      ...formData.value,
      // 确保日期格式正确
    }
    await UpdateCooperation(submitData)
    emit('success') // 添加这行触发success事件
    visible.value = false
  } catch (error) {
    console.error(error)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: _unref(visible),
    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
    title: _ctx.$t('Base.edit'),
    direction: "rtl",
    size: "50%"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        model: formData.value,
        "label-width": "120px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('Base.operatorName')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(SelectOperator, {
                            modelValue: formData.value.operatorId,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.operatorId) = $event)),
                            disabled: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('Base.cooperType')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: formData.value.cooperType,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.cooperType) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(CooperTypes).filter(item => item.value !== 0), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('Base.username')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formData.value.userName,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.userName) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('Base.phone')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formData.value.userPhone,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.userPhone) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('Base.referrerName')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formData.value.referrerName,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.referrerName) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('Base.referrerPhone')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formData.value.referrerPhone,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.referrerPhone) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('Base.remark')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formData.value.remark,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.remark) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('Base.state')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: formData.value.state,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.state) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(CooperStates).filter(item => item.value !== 0), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: handleSubmit
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.save')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})